import { AfterContentInit, Component, OnInit, ContentChildren, QueryList, ChangeDetectorRef, ChangeDetectionStrategy, AfterContentChecked } from '@angular/core';
import { TableComponent } from '../table/table.component';
import { TableColumnComponent } from '../table-column/table-column.component';

@Component({
  selector: 'app-table-header',
  templateUrl: './table-header.component.html',
  styleUrls: ['./table-header.component.css'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class TableHeaderComponent implements AfterContentInit {
  @ContentChildren(TableColumnComponent) columns: QueryList<TableColumnComponent>;
  columnCount!: number;

  hasAdditional = false;

  constructor(private changeDetector: ChangeDetectorRef) {

  }

  ngAfterContentInit() {
    this.columnCount = this.columns.length + 1;
    this.changeDetector.detectChanges();
  }
}
